import React, { useState } from "react";
import GradientButton from "../../components/button/Button";
import PlainButton from "../../components/button/PlainButton";

interface FilterModalProps {
  isOpen: boolean;
  onClose: () => void;
  onFilter: (filters: {
    orderId: string;
    orderDate: string;
    status: string;
    customerName: string;
    orderAmount: string;
  }) => void;
}

const PaymentModal: React.FC<FilterModalProps> = ({
  isOpen,
  onClose,
  onFilter,
}) => {
  const [filters, setFilters] = useState({
    orderId: "",
    orderDate: "",
    status: "",
    customerName: "",
    orderAmount: "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleFilter = () => {
    onFilter(filters);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="orders-modal">
      <div className="orders-modal__overlay" onClick={onClose}></div>
      <div className="orders-modal__content">
        <div className="orders__modal__header">
          <h2 className="orders-modal__title">Filter</h2>
          <button className="orders-modal__close" onClick={onClose}>
            &times;
          </button>
        </div>
        <form className="orders-modal__form">
          <div className="orders-modal__form-group">
            <label htmlFor="orderId">Order ID</label>
            <input
              type="text"
              id="orderId"
              name="orderId"
              placeholder="Enter Order ID"
              value={filters.orderId}
              onChange={handleChange}
            />
          </div>
          <div className="orders-modal__form-group">
            <label htmlFor="orderDate">Order Date</label>
            <input
              type="date"
              id="orderDate"
              name="orderDate"
              value={filters.orderDate}
              onChange={handleChange}
            />
          </div>
          <div className="orders-modal__form-group">
            <label htmlFor="status">Status</label>
            <select
              id="status"
              name="status"
              value={filters.status}
              onChange={handleChange}
            >
              <option value="">Select Order Status</option>
              <option value="Pending">Pending</option>
              <option value="Completed">Completed</option>
              <option value="Cancelled">Cancelled</option>
            </select>
          </div>
          <div className="orders-modal__form-group">
            <label htmlFor="orderAmount">Order Amount</label>
            <input
              type="number"
              id="orderAmount"
              name="orderAmount"
              placeholder="Enter Amount"
              value={filters.orderAmount}
              onChange={handleChange}
            />
          </div>
          <div className="orders-modal__form-group">
            <label htmlFor="customerName">Customer Name</label>
            <input
              type="text"
              id="customerName"
              name="customerName"
              placeholder="Enter Customer Name"
              value={filters.customerName}
              onChange={handleChange}
            />
          </div>
        </form>
        <div className="orders-modal__actions">
          <div className="orders-modal__clear">
            <PlainButton
              onClick={() =>
                setFilters({
                  orderId: "",
                  orderDate: "",
                  status: "",
                  customerName: "",
                  orderAmount: "",
                })
              }
              text="Clear Filter"
            />
          </div>
          <div className="orders-modal__apply">
            <GradientButton onClick={handleFilter} text="Filter" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;
